


































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PdQualityControlSetAdd from "./pdQualityControlSetAdd.vue";
import {
  GetQualityControlSetList,
  DeleteQualityControlSet
} from "@/api/pdQualityControlManage/pdQualityControlSet";
@Component({
  components: {
    PdQualityControlSetAdd
  }
})
export default class PdQualityControlSet extends AbpBase {
  showAddQualityControlSet: boolean = false;
  loading: boolean = false;
  QualityControlSetList: any[] = [];
  pdQualityControlSet: any = {};
  QualityControlSetColumns = [
    {
      title: "编号",
      key: "id"
    },
    {
      title: "检查项目",
      key: "typeName"
    },
    {
      title: "检查间隔(天)",
      key: "interval"
    },
    {
      title: "操作",
      key: "",
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "success", icon: "ios-create", size: "small" },
            style: { marginRight: "5px" },
            on: {
              click: () => {
                this.onQualityControlSetUpdate(p.row);
              }
            }
          }),
          h("Button", {
            props: { type: "error", icon: "ios-trash", size: "small" },
            style: { marginRight: "5px" },
            on: {
              click: () => {
                this.onQualityControlSetDelete(p.row.id);
              }
            }
          })
        ]);
      }
    }
  ];

  getData() {
    this.loading = true;
    this.pdQualityControlSet = {};
    GetQualityControlSetList().then(res => {
      this.QualityControlSetList = res.objects;
    });
    this.loading = false;
  }

  onAddQualityControlSet() {
    this.pdQualityControlSet = {
      id: 0,
      status: true
    };
    this.showAddQualityControlSet = true;
  }
  //新增质控设定
  onAddPdQualityControlSetOk() {
    this.$refs.PdQualityControlSetAdd.submit().then(res => {
      if (res) {
        this.showAddQualityControlSet = false;
        this.getData();
      }
    });
  }
  //删除质控设定
  onQualityControlSetDelete(id: any) {
    this.$confirm("确定要删除吗？", "提示").then(() => {
      DeleteQualityControlSet(id).then(res => {
        this.getData();
      });
    });
  }
  //修改质控设定
  onQualityControlSetUpdate(data: any) {
    this.pdQualityControlSet = data;
    this.showAddQualityControlSet = true;
  }
  constructor() {
    super();
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdQualityControlManage/pdQualityControlSet/index.vue